import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getSelectionListWidgetStyles = props => {
  var _props$variation = props.variation,
    variation = _props$variation === void 0 ? 'default' : _props$variation,
    _props$inputProps = props.inputProps,
    inputProps = _props$inputProps === void 0 ? {} : _props$inputProps,
    _props$buttonProps = props.buttonProps,
    buttonProps = _props$buttonProps === void 0 ? {} : _props$buttonProps;
  var isColumn = variation === 'full-size';
  var flex = {
    input: 0.5,
    button: 0.5
  };
  if (variation == 'cvv-size') {
    flex.input = 0.35;
    flex.button = 0.65;
  }
  if (variation == 'full-size') {
    flex.input = 1;
    flex.button = 1;
  }
  var hasInput = !!Object.keys(inputProps).length;
  var hasButton = !!Object.keys(buttonProps).length;
  return StyleSheet.create({
    callout: {
      marginTop: tokens.spacing.SPACING_8
    },
    content: {
      paddingHorizontal: tokens.spacing.SPACING_16
    },
    buttonAndInputGroup: Object.assign({
      marginTop: tokens.spacing.SPACING_8,
      flexDirection: isColumn ? 'column' : 'row'
    }, isColumn && {
      alignItems: 'center'
    }),
    input: {
      width: '100%',
      flex: !hasButton ? 1 : flex.input
    },
    button: Object.assign({
      width: '100%',
      flex: !hasInput ? 1 : flex.button
    }, hasInput ? isColumn ? {
      marginTop: tokens.spacing.SPACING_8
    } : {
      marginLeft: tokens.spacing.SPACING_8
    } : {})
  });
};